 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"layout-default-Index":"layout-default-Index","views-ActivitiesList~views-Activity~views-Calendar~views-Inventory~views-Invoice~views-Learning~views-Match":"views-ActivitiesList~views-Activity~views-Calendar~views-Inventory~views-Invoice~views-Learning~views-Match","views-Activity":"views-Activity","views-ActivitiesList":"views-ActivitiesList","views-Calendar":"views-Calendar","views-Inventory~views-Invoice~views-Learning~views-Match":"views-Inventory~views-Invoice~views-Learning~views-Match","views-Inventory":"views-Inventory","views-Invoice":"views-Invoice","views-Learning":"views-Learning","views-Match":"views-Match","views-AddActivityField":"views-AddActivityField","views-Dashboard":"views-Dashboard","views-Error":"views-Error","views-GoogleMaps":"views-GoogleMaps","views-Icons":"views-Icons","views-Notifications":"views-Notifications","views-RegularTables":"views-RegularTables","views-Roster":"views-Roster","views-TeamComms":"views-TeamComms","views-TeamStat":"views-TeamStat","views-TodoDetailModal":"views-TodoDetailModal","views-Typography":"views-Typography","views-UserProfile":"views-UserProfile","default-app-bar":"default-app-bar","default-drawer":"default-drawer","default-footer":"default-footer","default-view":"default-view","default-account":"default-account","default-drawer-toggle":"default-drawer-toggle","default-go-home":"default-go-home","default-notifications":"default-notifications","default-upgrade":"default-upgrade","default-drawer-header":"default-drawer-header","default-list":"default-list"}[chunkId]||chunkId) + "." + {"layout-default-Index":"8ad285fd","views-ActivitiesList~views-Activity~views-Calendar~views-Inventory~views-Invoice~views-Learning~views-Match":"afaf6a3e","views-Activity":"98edc9e7","views-ActivitiesList":"bcd1d8d8","views-Calendar":"3b7714e7","views-Inventory~views-Invoice~views-Learning~views-Match":"e4781fbc","views-Inventory":"c9d9dd2e","views-Invoice":"6cdbee19","views-Learning":"a7152141","views-Match":"29ffdb35","views-AddActivityField":"2a121005","views-Dashboard":"ba26fe15","views-Error":"e5e72ae8","views-GoogleMaps":"6b57197a","views-Icons":"9b0172d5","views-Notifications":"e67106af","views-RegularTables":"996280ca","views-Roster":"45089981","views-TeamComms":"cb6fd884","views-TeamStat":"a94ed85d","views-TodoDetailModal":"9d8229ff","views-Typography":"56a9a80f","views-UserProfile":"e0c3f190","default-app-bar":"e54daa3a","default-drawer":"e11a8ecc","default-footer":"3ac20fa4","default-view":"6231568d","default-account":"67209d98","default-drawer-toggle":"b39ac924","default-go-home":"5b6635d8","default-notifications":"d1ae8a16","default-upgrade":"d0f17612","default-drawer-header":"1437dd90","default-list":"d74b6375","chunk-1efb9e0d":"a0c2f7f8","chunk-6584e3da":"d5c994d8","chunk-2d21e5a6":"81a5790c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"layout-default-Index":1,"views-ActivitiesList~views-Activity~views-Calendar~views-Inventory~views-Invoice~views-Learning~views-Match":1,"views-Activity":1,"views-ActivitiesList":1,"views-Calendar":1,"views-Inventory~views-Invoice~views-Learning~views-Match":1,"views-Inventory":1,"views-Invoice":1,"views-Learning":1,"views-Match":1,"views-Error":1,"views-Icons":1,"views-Notifications":1,"views-RegularTables":1,"views-Roster":1,"views-TeamComms":1,"views-TodoDetailModal":1,"views-UserProfile":1,"default-app-bar":1,"default-drawer":1,"default-footer":1,"default-view":1,"default-account":1,"default-notifications":1,"default-drawer-header":1,"default-list":1,"chunk-1efb9e0d":1,"chunk-6584e3da":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"layout-default-Index":"layout-default-Index","views-ActivitiesList~views-Activity~views-Calendar~views-Inventory~views-Invoice~views-Learning~views-Match":"views-ActivitiesList~views-Activity~views-Calendar~views-Inventory~views-Invoice~views-Learning~views-Match","views-Activity":"views-Activity","views-ActivitiesList":"views-ActivitiesList","views-Calendar":"views-Calendar","views-Inventory~views-Invoice~views-Learning~views-Match":"views-Inventory~views-Invoice~views-Learning~views-Match","views-Inventory":"views-Inventory","views-Invoice":"views-Invoice","views-Learning":"views-Learning","views-Match":"views-Match","views-AddActivityField":"views-AddActivityField","views-Dashboard":"views-Dashboard","views-Error":"views-Error","views-GoogleMaps":"views-GoogleMaps","views-Icons":"views-Icons","views-Notifications":"views-Notifications","views-RegularTables":"views-RegularTables","views-Roster":"views-Roster","views-TeamComms":"views-TeamComms","views-TeamStat":"views-TeamStat","views-TodoDetailModal":"views-TodoDetailModal","views-Typography":"views-Typography","views-UserProfile":"views-UserProfile","default-app-bar":"default-app-bar","default-drawer":"default-drawer","default-footer":"default-footer","default-view":"default-view","default-account":"default-account","default-drawer-toggle":"default-drawer-toggle","default-go-home":"default-go-home","default-notifications":"default-notifications","default-upgrade":"default-upgrade","default-drawer-header":"default-drawer-header","default-list":"default-list"}[chunkId]||chunkId) + "." + {"layout-default-Index":"0664c3d7","views-ActivitiesList~views-Activity~views-Calendar~views-Inventory~views-Invoice~views-Learning~views-Match":"ed2297b4","views-Activity":"0ce6bc32","views-ActivitiesList":"a578d552","views-Calendar":"f77cd482","views-Inventory~views-Invoice~views-Learning~views-Match":"b9e8f43e","views-Inventory":"0664c3d7","views-Invoice":"0664c3d7","views-Learning":"f775a83b","views-Match":"0664c3d7","views-AddActivityField":"31d6cfe0","views-Dashboard":"31d6cfe0","views-Error":"41c12922","views-GoogleMaps":"31d6cfe0","views-Icons":"8b8f4869","views-Notifications":"7bad8f53","views-RegularTables":"3613ae8b","views-Roster":"fbafb5c2","views-TeamComms":"04e8b0f7","views-TeamStat":"31d6cfe0","views-TodoDetailModal":"31bd0264","views-Typography":"31d6cfe0","views-UserProfile":"7bad8f53","default-app-bar":"f124e675","default-drawer":"9ccb0f2d","default-footer":"de049660","default-view":"f4f2c1ce","default-account":"0024a2ff","default-drawer-toggle":"31d6cfe0","default-go-home":"31d6cfe0","default-notifications":"7acc0d66","default-upgrade":"31d6cfe0","default-drawer-header":"f5f6a88a","default-list":"4a48f088","chunk-1efb9e0d":"31e4886e","chunk-6584e3da":"31e4886e","chunk-2d21e5a6":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
